// Compiled at 2026-10-07T06:21:14.975Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { jsonClass } from "@sumbricht/json-class-serializer";

const cache = new Map<string, any>();

export class $Config {
    static get LookAndFeel() {
        return {
            'isBranded': typeof true == 'boolean' ? true : (true as any) !== 'false'
        }
    }
}
